import { IntegrationService } from '@sequencehq/core-models'

export function integrationName(
  integrationService: IntegrationService
): string {
  return integrationService.replaceAll('_', ' ')
}
